import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button, Select } from '../base';
import { generateYearList } from '../../utils/transformer.util';

export default function StudentReportFilter(props) {
  const {
    onSearch, onChange,
    year, error,
  } = props;
  return (
    <div className="filter">
      <div className="filter__student">
        <Select
          name="year"
          label="Tahun Ajaran"
          placeholder="Pilih tahun ajaran"
          data={generateYearList()}
          onChange={onChange}
          value={year}
          error={error}
        />
      </div>
      <Button
        title="Cari"
        onClick={onSearch}
      />
    </div>
  );
}
StudentReportFilter.propTypes = {
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  year: PropTypes.string,
  error: PropTypes.string,
};
StudentReportFilter.defaultProps = {
  onChange: noop,
  onSearch: noop,
  year: '',
  error: '',
};
